import React from 'react';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface RouteErrorBoundaryProps {
  children: React.ReactNode;
  routeName?: string;
}

const RouteErrorFallback = ({ routeName }: { routeName?: string }) => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <Card className="max-w-lg w-full">
        <CardHeader>
          <div className="flex items-center gap-2 mb-2">
            <AlertTriangle className="h-6 w-6 text-destructive" />
            <CardTitle>Sidfel</CardTitle>
          </div>
          <CardDescription>
            Ett fel inträffade när {routeName || 'sidan'} laddades.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-2">
          <Button onClick={() => window.location.reload()} className="w-full">
            Försök igen
          </Button>
          <Button 
            variant="outline" 
            onClick={() => navigate(-1)} 
            className="w-full"
          >
            Gå tillbaka
          </Button>
          <Button 
            variant="ghost" 
            onClick={() => navigate('/')} 
            className="w-full"
          >
            Hem
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export const RouteErrorBoundary = ({ children, routeName }: RouteErrorBoundaryProps) => {
  return (
    <ErrorBoundary fallback={<RouteErrorFallback routeName={routeName} />}>
      {children}
    </ErrorBoundary>
  );
};
